// Widget Scripts
import customTicketBtn from './js/widgets/customTicketBtn.js';
import vimeoFeature from './js/widgets/mainFeature/vimeoFeature.js';
import seoWidget from './js/widgets/seoMap/seoWidget.js';
import * as eventsAndHotButtons from './js/widgets/eventsAndHotButtons/index.js';
import * as sponsors from './js/widgets/sponsors/index.js';
import affiliatesLogos from './js/widgets/affiliatesLogos.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketBtn();
  if (globalThis.location.pathname === '/') {
    vimeoFeature();
    seoWidget();
    eventsAndHotButtons.eventFeed();
    eventsAndHotButtons.hotButtons();
    sponsors.scrollerSponsors();
    sponsors.majorSponsors();
  }
  affiliatesLogos();
});
